import { useMutation, UseMutationResult } from "react-query"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { api } from "../../api"
import { localConfig } from "../../../Configs/localConfig"

interface PropsPostCargos {
  nome: string
  descricao: string
  refetch_cargos: Function
}

export const usePostCargo = (): {
  carregando_salvar_cargos: boolean
  mutate_cargos: (params: PropsPostCargos) => void
  isSuccess_cargos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostCargos> = useMutation(
    async (params: PropsPostCargos) => {
      const {
       nome,
       descricao,
       refetch_cargos
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/adm/cargo?codConta=${localConfig()?.conta}`,{
          nome,
          descricao
        })
        .then((response: any) => {
          successAlert('Cargo cadastrado com sucesso!', 5000, 'loading')
          refetch_cargos()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
       
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar cargo!', 5000, 'loading')
            })
          } else {
         
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar cargo!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_cargos: mutation.isLoading,
    mutate_cargos: mutation.mutate,
    isSuccess_cargos: mutation.isSuccess,
  }
}

export const usePutCargo = (
  cod: number
): {
  carregando_edit_cargos: boolean
  mutate_edit_cargos: (params: PropsPostCargos) => void
  isSuccess_edit_cargos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostCargos> = useMutation(
    async (params: PropsPostCargos) => {
      const {
        nome,
        descricao,
           refetch_cargos
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`/adm/cargo/${cod}?codConta=${localConfig()?.conta}`, {
          nome: nome,
          descricao: descricao
        })
        .then((response: any) => {
          successAlert('Cargo atualizado com sucesso!', 5000, 'loading')
          refetch_cargos()
          return response
        })
        .catch((error: any) => {
          errorAlert(
            error?.response?.data?.error ?? 'Falha ao editar a cargo!',
            5000,
            'loading'
          )
          throw error
        })
    }
  )

  return {
    carregando_edit_cargos: mutation.isLoading,
    mutate_edit_cargos: mutation.mutate,
    isSuccess_edit_cargos: mutation.isSuccess,
  }
}
